module.exports = __webpack_public_path__ + "static/media/slide1.13d5ba33.webp";